/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Save_Preset_ConfirmInputs */

const en_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Preset`)
};

const fr_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer le prereglage`)
};

const de_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung speichern`)
};

const it_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva preimpostazione`)
};

const ru_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить предустановку`)
};

const es_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar ajuste preestablecido`)
};

const zh_cn2_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存预设`)
};

const ja_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを保存`)
};

const hi_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट सहेजें`)
};

const pt_pt2_video_export_save_preset_confirm = /** @type {(inputs: Video_Export_Save_Preset_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar predefinição`)
};

/**
* | output |
* | --- |
* | "Save Preset" |
*
* @param {Video_Export_Save_Preset_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_save_preset_confirm = /** @type {((inputs?: Video_Export_Save_Preset_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Save_Preset_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_save_preset_confirm(inputs)
	if (locale === "de") return de_video_export_save_preset_confirm(inputs)
	if (locale === "it") return it_video_export_save_preset_confirm(inputs)
	if (locale === "ru") return ru_video_export_save_preset_confirm(inputs)
	if (locale === "es") return es_video_export_save_preset_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_save_preset_confirm(inputs)
	if (locale === "ja") return ja_video_export_save_preset_confirm(inputs)
	if (locale === "hi") return hi_video_export_save_preset_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_save_preset_confirm(inputs)
	return en_video_export_save_preset_confirm(inputs)
});